import { useEffect, useState } from 'react';
import { Card, Accordion } from 'react-bootstrap';
//import { Accordion } from 'react-bootstrap';
import {
  AccordionDownArrow,
  AccordionUpArrow,
} from '../../../../img/findcare/FindCareSVG';
import './MessageDetailComponent.scss';
import {
  AttachmentPinSymbolSVG,
  AttachedFileSymbolSVG,
  FileDownloadSymbolSVG,
  ReplySymbolSVG,
  ReplyAllSymbolSVG,
} from 'src/Member/img/NotificationSVG';
//import SendMessage from './SendMessage';
import { useSelector } from 'react-redux';
import { formatMessageDateAndTime } from 'src/common/utils';
import SendMessage from './SendMessage';

const MessageDetailComponent = ({
  isComposing,
  setIsComposing,
  replyEnabled,
  setReplyEnabled,
  selectedData,
  getSanitizedContent,
  isUpdateAndReminder = false,
  onDownload = (item) => console.log('item to download', item),
  onDownloadAll = (items) => console.log('download all file', items),
  setIsComposed,
}) => {
  useEffect(() => {
    console.log('selectedData', selectedData, viewAll);

    setViewAll(false);
  }, [selectedData]);

  const { Sender_Email } = useSelector(
    (state) => state?.app?.appConfigs?.Email_Configration,
  );

  const [activeId, setActiveId] = useState(0);

  const [viewAll, setViewAll] = useState(false);

  const initialVals = 3;
  let showMore = false;

  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };
  const getMessageTypes = (typeValue) => {
    const messageType = typeValue;
    if (messageType === 'Claims') {
      return <span className="claim-class">{messageType}</span>;
    } else if (messageType === 'Authorizations') {
      return <span className="Authorizations-class">{messageType}</span>;
    } else {
      return <span className="enrollment-class">{messageType}</span>;
    }
  };
  return (
    <div className="message_detail_section">
      {!isComposing && (
        <div className="d-flex flex-row justify-content-between bg-white p-3">
          <div className="message_title">{selectedData?.EventTitle}</div>
          <div>
            {getMessageTypes(
              selectedData?.MessagecategorymasterDTOObj?.Categorydesc,
            )}
          </div>
        </div>
      )}
      {(replyEnabled || isComposing) && (
        <div>
          <SendMessage
            isComposing={isComposing}
            setIsComposing={setIsComposing}
            setReplyEnabled={setReplyEnabled}
            setIsComposed={setIsComposed}
          />
        </div>
      )}
      {!isComposing && (
        <div>
          <Accordion defaultActiveKey="0">
            <Card className="mt-3">
              <Accordion.Toggle
                as={Card.Header}
                onClick={() => toggleActive(0)}
                className="panel-toggle bg-white text-left w-100"
                eventKey="0"
              >
                <div className="d-flex justify-content-between panel-card-header">
                  <div className="d-flex">
                    <div className="pr-3 pt-2">
                      <span className="accordion-arrow">
                        {activeId === 0 ? (
                          <AccordionDownArrow className="acc-arrow" />
                        ) : (
                          <AccordionUpArrow className="acc-arrow" />
                        )}
                      </span>
                    </div>
                    <div className="">
                      <span className="message-detail-user-icon-img">
                        {Sender_Email.charAt(0)}
                      </span>
                    </div>
                    <div className="pl-3">
                      <span className="msg_from">To: {Sender_Email}</span>{' '}
                      <br />
                      {/*<span>To: {selectedData.To}</span> */}
                    </div>
                  </div>

                  <div className="d-flex flex-column">
                    {activeId === 0 && !isUpdateAndReminder && !!false ? (
                      <span className="text-right">
                        <span
                          className="cursor-pointer mr-2"
                          onClick={() => setReplyEnabled(true)}
                        >
                          <ReplySymbolSVG className="message_reply_svg" />
                        </span>
                        <span
                          className="cursor-pointer"
                          onClick={() => setReplyEnabled(true)}
                        >
                          <ReplyAllSymbolSVG className="message_reply_svg" />
                        </span>
                      </span>
                    ) : (
                      ''
                    )}

                    <span className="msgreceivedinfo">
                      {formatMessageDateAndTime(selectedData?.ReceivedDateTime)}
                    </span>
                  </div>
                </div>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="0">
                <Card.Body className="p-0">
                  {selectedData?.attachments === true ? (
                    <div className="d-flex flex-column attachment-div p-3">
                      <div>
                        <AttachmentPinSymbolSVG className="attachmentpinsymbol-svg" />
                        <span className="pl-2 attachment-counts">
                          Attachments ({selectedData?.attachmentsDetail?.length}
                          )
                        </span>
                        {selectedData?.attachmentsDetail?.length > 1 ? (
                          <span
                            className="download_All pl-3 cursor-pointer"
                            onClick={() => onDownloadAll(selectedData)}
                          >
                            <FileDownloadSymbolSVG className="message_file_download_svg" />{' '}
                            Download All
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className="msg-attachment-wrapper">
                        {selectedData?.attachmentsDetail
                          ?.filter((item, index) => {
                            if (!viewAll && index >= initialVals) {
                              showMore = true;
                              return false;
                            }
                            showMore = false;
                            return true;
                          })
                          .map((item, index) => {
                            return (
                              <div
                                className="d-flex flex-row attachment-container mt-2"
                                key={index}
                              >
                                <div>
                                  <AttachedFileSymbolSVG className="attachment-icon-container" />
                                </div>
                                <div className="p-2 file_attachement_name">
                                  {item?.OrigFileName}
                                </div>
                                <div
                                  className="cursor-pointer"
                                  onClick={() =>
                                    onDownload({
                                      ...item,
                                      isDmsDoc: selectedData?.isDmsDoc,
                                    })
                                  }
                                >
                                  <FileDownloadSymbolSVG className="message_file_download_svg" />
                                </div>
                              </div>
                            );
                          })}
                      </div>
                      {showMore && !viewAll && (
                        <span
                          className="View_All_Attachments"
                          onClick={() => setViewAll(true)}
                        >
                          View All Attachments
                        </span>
                      )}
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="p-3">
                    {/*<p className="msg_body">{selectedData?.EventDesc}</p> */}
                    <p
                      className="msg_body"
                      dangerouslySetInnerHTML={{
                        __html: getSanitizedContent(
                          selectedData?.EventDesc?.trim(),
                        ),
                      }}
                    />
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
      )}
    </div>
  );
};

export default MessageDetailComponent;
